import { createFileRoute } from "@tanstack/react-router";
import { Lock, Trash2 } from "lucide-react";
import { useState } from "react";

import { DescarteFilterPanel } from "@/features/descarte/components/descarte-filters";
import { MessagingSectionTabs } from "@/features/messaging/components/shared/messaging-section-tabs";
import { DescarteTable } from "@/features/descarte/components/descarte-table";
import type { DescarteFilters } from "@/features/descarte/services/descarte.service";
import { useCurrentUserRole } from "@/lib/team";
import { can } from "@simplificalo/contracts/permissions";

export const Route = createFileRoute("/_app/correo/audit-descarte")({
  component: AuditDescartePage,
});

function AuditDescartePage() {
  const role = useCurrentUserRole();
  const [filters, setFilters] = useState<DescarteFilters>({});

  if (!can(role, "correo.inbox.view")) {
    return (
      <div
        className="mx-auto flex max-w-md flex-col items-center justify-center gap-3 rounded-lg border py-16 text-center"
        style={{ borderColor: "var(--color-border)" }}
      >
        <Lock className="h-6 w-6" style={{ color: "var(--color-fg-subtle)" }} aria-hidden />
        <h2 className="text-base font-semibold" style={{ color: "var(--color-fg)" }}>
          Acceso restringido
        </h2>
        <p className="text-sm" style={{ color: "var(--color-fg-muted)" }}>
          No tienes permiso para acceder a esta vista.
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      <MessagingSectionTabs active="descartes" />
      <header className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex items-start gap-3">
          <span
            className="flex h-9 w-9 items-center justify-center rounded-md"
            style={{ background: "var(--color-bg-overlay)" }}
            aria-hidden
          >
            <Trash2
              className="h-4 w-4"
              style={{ color: "var(--color-fg-muted)" }}
            />
          </span>
          <div>
            <h1 className="text-2xl font-semibold">Auditoría de Descarte</h1>
            <p
              className="text-sm"
              style={{ color: "var(--color-fg-muted)" }}
            >
              Registro de correos descartados por el pipeline de ingesta.
              Consulta por remitente, cuenta o rango de fechas.
            </p>
          </div>
        </div>
      </header>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-[260px_1fr]">
        <DescarteFilterPanel value={filters} onChange={setFilters} />
        <DescarteTable
          filters={filters}
          onPageChange={(offset) => setFilters((prev) => ({ ...prev, offset }))}
        />
      </div>
    </div>
  );
}
